import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Loader, Grid, Modal } from 'semantic-ui-react';
import { KR, US } from 'country-flag-icons/react/3x2';
import cx from 'classnames';
import { withTranslation } from 'react-i18next';
import api from '../../api';
//import progress from '../../images/icons/progress_ica.gif';
import WithRouter from '../Extensions/WithRouter';
//import history from '../Extensions/History';

class LanguageSystem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPageLoading: false,
      isOpenModal: false,
      selectedLocale: 'en'
    };
    this.handleSave = this.handleSave.bind(this);
    this.handleLocale = this.handleLocale.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getLocaleWithCompany();
      this.setState({
        isPageLoading: false,
      });
    }
  }

  handleSave() {
    this.setState({
      isOpenModal: true,
    });
  }

  handleLocale(value) {
    const { selectedLocale } = this.state;
    if (selectedLocale === value) {
      return;
    }
    this.setState({
      selectedLocale: value,
    });
  }

  handleModal() {
    const { selectedLocale } = this.state;
    const obj = {
      locale: selectedLocale,
    };

    api
      .setLocaleWithCompany(obj)
      .then((res) => {
        const data = res.response;
        this.setState({
          selectedLocale: data.locale,
          isOpenModal: false,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isOpenModal: false,
        });
      });
  }

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  getLocaleWithCompany() {
    api
      .getLocaleWithCompany()
      .then((res) => {
        const data = res.response;
        const filteredData = data.filter((item) => {
          return item.selected === true;
        });

        this.setState({
          selectedLocale: filteredData[0].locale,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  closeModal() {
    this.setState({
      isOpenModal: false,
    });
  }

  render() {
    const {
      isLoading,
      isOpenModal,
      selectedLocale,
    } = this.state;

    const { t } = this.props;

    const renderIfReady = (element) => {
      return (
        isLoading
          ? (
            <div style={{ height: '170px', paddingTop: '9%' }}>
              <Loader size="medium" active={isLoading} inline="centered" />
            </div>
          )
          : element
      );
    };

    return (
      <div>
        <div className="content">
          <div className="setting_small_box">
            <h2 className="page_title">{t('system.language.settings')}</h2>
            {
              renderIfReady(
                <div>
                  <div className="setting_contnets">
                    <div className="setting_contnet_wrap">
                      <h3 className="setting_content_title">
                        {t('system.language.choose_lang')}
                      </h3>
                      <div className="setting_content" style={{ marginTop: '30px' }}>
                        <Grid relaxed columns={8}>
                          <Grid.Column>
                            <a
                              className={cx('country_flag', {
                                selected: selectedLocale === 'ko',
                              })}
                              onClick={() => {
                                return this.handleLocale('ko');
                              }}
                              onKeyUp={() => {
                                return this.handleLocale('ko');
                              }}
                            >
                              <KR title="한국어" />
                            </a>
                          </Grid.Column>
                          <Grid.Column>
                            <a
                              className={cx('country_flag', {
                                selected: selectedLocale === 'en',
                              })}
                              onClick={() => {
                                return this.handleLocale('en');
                              }}
                              onKeyUp={() => {
                                return this.handleLocale('en');
                              }}
                            >
                              <US title="English" />
                            </a>
                          </Grid.Column>
                          <Grid.Column />
                          <Grid.Column />
                        </Grid>
                      </div>
                      <div className="setting_bottom">
                        <a
                          className="save"
                          onClick={this.handleSave}
                          onKeyUp={this.handleSave}
                          style={{ cursor: 'pointer' }}
                        >
                          {t('modal.button.save')}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              )
            }
            <Modal
              open={isOpenModal}
              onClose={this.closeModal}
            >
              <div className="modal_popup_wrap confirm_wrap">
                <div className="modal_popup_box confirm_box">
                  <div className="modal_popup confirm">
                    <h2 className="title">
                      {t('modal.title.attention')}
                    </h2>
                    <div className="text">
                      <div className="text">{t('system.language.change_company_lang')}</div>
                      <div className="small_text">{t('system.language.change_company_lang_sub')}</div>
                    </div>
                    <div className="button_wrap">
                      <a
                        className="left_button"
                        onClick={this.closeModal}
                        onKeyUp={this.closeModal}
                      >
                        {t('modal.button.no')}
                      </a>
                      <a
                        className="right_button"
                        onClick={this.handleModal}
                        onKeyUp={this.handleModal}
                      >
                        {t('modal.button.yes')}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LanguageSystem))));
